module.exports = __webpack_public_path__ + "static/media/ordergrey.9d9b237a.svg";